// Shared static data — subsidiaries, projects, news
// This data is language-agnostic (or has FR/EN variants where needed).

export const SUBSIDIARIES = [
  {
    id: "kidh",
    slug: "kidh",
    name: "KIDH",
    fullName: "Kipyz Design & Houses",
    accent: "#E8611A",
    icon: "home",
    tagline: {
      fr: "Des quartiers, pas des immeubles.",
      en: "Neighborhoods, not just buildings.",
    },
    description: {
      fr: "Développeur immobilier intégré. KIDH conçoit, construit et exploite des quartiers de vie modernes — résidentiels, commerciaux et hôteliers — sur 8 pôles urbains de la Côte d'Ivoire.",
      en: "Integrated real estate developer. KIDH designs, builds and operates modern living neighborhoods — residential, commercial and hospitality — across 8 urban hubs in Côte d'Ivoire.",
    },
    kpis: [
      { value: "60 000", label: { fr: "Logements planifiés", en: "Homes planned" } },
      { value: "8", label: { fr: "Pôles urbains", en: "Urban hubs" } },
      { value: "300 000", label: { fr: "Personnes logées", en: "People housed" } },
    ],
    href: "https://kidh.ci",
  },
  {
    id: "kip-energy",
    slug: "kip-energy",
    name: "Kip Energy",
    fullName: "Kip Energy",
    accent: "#E30613",
    icon: "zap",
    tagline: {
      fr: "L'énergie au cœur de l'écosystème.",
      en: "Energy at the heart of the ecosystem.",
    },
    description: {
      fr: "Opérateur du réseau national de stations Wayne. Kip Energy déploie 100 stations-service premium avec boutiques intégrées, en exclusivité Wayne Technologies pour la Côte d'Ivoire.",
      en: "Operator of the national Wayne station network. Kip Energy is rolling out 100 premium service stations with integrated retail, exclusive Wayne Technologies partner in Côte d'Ivoire.",
    },
    kpis: [
      { value: "100", label: { fr: "Stations en déploiement", en: "Stations deploying" } },
      { value: "7", label: { fr: "Phases SPV", en: "SPV phases" } },
      { value: "1", label: { fr: "Exclusivité Wayne CI", en: "Wayne CI exclusivity" } },
    ],
    href: "https://wayne.ci",
  },
  {
    id: "ekiptech",
    slug: "ekiptech",
    name: "EKIPTECH",
    fullName: "EKIPTECH",
    accent: "#1E88E5",
    icon: "cpu",
    tagline: {
      fr: "La technologie connectée à votre quotidien.",
      en: "Technology connected to your daily life.",
    },
    description: {
      fr: "Filiale technologique — plateformes digitales, IoT, hardware connecté et distribution Zebra Technologies. EKIPTECH équipe les entreprises et les foyers avec les solutions connectées du futur.",
      en: "Technology arm — digital platforms, IoT, connected hardware and Zebra Technologies distribution. EKIPTECH equips businesses and homes with the connected solutions of the future.",
    },
    kpis: [
      { value: "B2B/B2C", label: { fr: "Modèle mixte", en: "Mixed model" } },
      { value: "Zebra", label: { fr: "Partenaire exclusif", en: "Exclusive partner" } },
      { value: "AO", label: { fr: "Afrique de l'Ouest", en: "West Africa" } },
    ],
    href: "https://ekiptech.ci",
  },
  {
    id: "kipay",
    slug: "kipay",
    name: "KIPAY",
    fullName: "KIPAY",
    accent: "#00B894",
    icon: "wallet",
    tagline: {
      fr: "Payer, épargner, fidéliser — en un geste.",
      en: "Pay, save, get rewarded — in one gesture.",
    },
    description: {
      fr: "Solution de paiement digital multi-enseignes. KIPAY unifie l'expérience client à travers l'écosystème EKIP et les partenaires : wallet, cashless, crédit conso et fidélité.",
      en: "Multi-brand digital payments solution. KIPAY unifies the customer experience across the EKIP ecosystem and partners: wallet, cashless, consumer credit and loyalty.",
    },
    kpis: [
      { value: "8", label: { fr: "Banques partenaires", en: "Bank partners" } },
      { value: "Multi", label: { fr: "Enseignes intégrées", en: "Brands integrated" } },
      { value: "Wallet", label: { fr: "Portefeuille digital", en: "Digital wallet" } },
    ],
    href: "https://kipay.ci",
  },
  {
    id: "ekip-capital",
    slug: "ekip-capital",
    name: "EKIP Capital",
    fullName: "EKIP Capital",
    accent: "#C49A3C",
    icon: "trending-up",
    tagline: {
      fr: "Investir dans l'avenir africain.",
      en: "Investing in Africa's future.",
    },
    description: {
      fr: "Plateforme de gestion d'actifs (agrément AMF-UMOA en cours). EKIP Capital structure les véhicules d'investissement du groupe et ouvre l'écosystème à des co-investisseurs institutionnels.",
      en: "Asset management platform (AMF-UMOA licensing in progress). EKIP Capital structures the group's investment vehicles and opens the ecosystem to institutional co-investors.",
    },
    kpis: [
      { value: "AMF-UMOA", label: { fr: "Agrément en cours", en: "Licensing pending" } },
      { value: "Multi", label: { fr: "SPV structurés", en: "Structured SPVs" } },
      { value: "Pipeline", label: { fr: "Multi-secteurs", en: "Multi-sector" } },
    ],
    href: "#",
  },
];

export const PROJECTS = [
  {
    id: "vision-2035",
    slug: "vision-2035",
    title: "Vision 2035",
    subtitle: {
      fr: "Programme national d'habitat intégré",
      en: "National integrated housing program",
    },
    badge: "60 000 logements",
    type: "immobilier",
    image:
      "https://images.pexels.com/photos/9321327/pexels-photo-9321327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    description: {
      fr: "8 pôles urbains, 60 000 logements, 300 000 personnes logées à horizon 2035. Un programme d'habitat intégré alliant résidentiel, commerce, énergie et services digitaux.",
      en: "8 urban hubs, 60,000 homes, 300,000 people housed by 2035. An integrated housing program combining residential, retail, energy and digital services.",
    },
    partners: ["KIDH", "Kip Energy", "EKIPTECH", "KIPAY"],
    kpis: [
      { value: "60 000", label: { fr: "Logements", en: "Homes" } },
      { value: "8", label: { fr: "Pôles urbains", en: "Urban hubs" } },
      { value: "300 000", label: { fr: "Personnes logées", en: "People housed" } },
      { value: "47 000", label: { fr: "Emplois", en: "Jobs" } },
    ],
    locations: [
      { name: "Angré", x: 63, y: 78 },
      { name: "Dabou", x: 55, y: 84 },
      { name: "Bingerville", x: 68, y: 81 },
      { name: "Grand-Bassam", x: 71, y: 83 },
      { name: "Bouaké", x: 56, y: 42 },
      { name: "Yamoussoukro", x: 56, y: 55 },
      { name: "Korhogo", x: 48, y: 22 },
      { name: "San-Pédro", x: 26, y: 87 },
    ],
  },
  {
    id: "reseau-wayne",
    slug: "reseau-wayne",
    title: "Réseau Wayne",
    subtitle: {
      fr: "100 stations en Côte d'Ivoire",
      en: "100 stations across Côte d'Ivoire",
    },
    badge: "100 stations",
    type: "energie",
    image:
      "https://images.pexels.com/photos/11219000/pexels-photo-11219000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    description: {
      fr: "Déploiement en 7 phases SPV du réseau national de stations Wayne — couverture nationale et corridors transfrontaliers. Chaque station intègre carburant, retail et services digitaux.",
      en: "7-phase SPV rollout of the national Wayne station network — nationwide coverage plus cross-border corridors. Each station integrates fuel, retail and digital services.",
    },
    partners: ["Wayne Technologies", "Wayne Africa"],
    kpis: [
      { value: "100", label: { fr: "Stations", en: "Stations" } },
      { value: "7", label: { fr: "Phases SPV", en: "SPV phases" } },
      { value: "CI+", label: { fr: "Corridors transfrontaliers", en: "Cross-border corridors" } },
    ],
    locations: [
      { name: "Abidjan", x: 65, y: 82 },
      { name: "Yamoussoukro", x: 56, y: 55 },
      { name: "San-Pédro", x: 26, y: 87 },
      { name: "Bouaké", x: 56, y: 42 },
      { name: "Korhogo", x: 48, y: 22 },
      { name: "Man", x: 22, y: 48 },
    ],
  },
  {
    id: "sassandra",
    slug: "sassandra",
    title: "Sassandra Integrated Resort",
    subtitle: {
      fr: "Resort balnéaire intégré",
      en: "Integrated seaside resort",
    },
    badge: "1 031 hectares",
    type: "tourisme",
    image:
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=compress&cs=tinysrgb&fm=jpg&w=1200&q=80",
    description: {
      fr: "1 031 hectares en front de mer. Resort hôtelier, golf, marina, éco-lodges, villas — en joint-venture avec Beachcomber Hotels. Un IRS d'inspiration mauricienne au cœur de la Côte d'Ivoire.",
      en: "1,031 seafront hectares. Hotel resort, golf, marina, eco-lodges, villas — joint venture with Beachcomber Hotels. A Mauritian-inspired IRS in the heart of Côte d'Ivoire.",
    },
    partners: ["Beachcomber Hotels"],
    kpis: [
      { value: "1 031", label: { fr: "Hectares", en: "Hectares" } },
      { value: "350+", label: { fr: "Emplois directs", en: "Direct jobs" } },
      { value: "IRS", label: { fr: "Schéma resort", en: "Resort scheme" } },
    ],
    locations: [{ name: "Sassandra", x: 32, y: 88 }],
  },
  {
    id: "gestoci",
    slug: "gestoci",
    title: "GESTOCI EPC+F",
    subtitle: {
      fr: "Infrastructure pétrolière stratégique",
      en: "Strategic petroleum infrastructure",
    },
    badge: "3 sites stratégiques",
    type: "infrastructure",
    image:
      "https://images.unsplash.com/photo-1518709594023-6ebbf05c62dc?auto=compress&cs=tinysrgb&fm=jpg&w=1200&q=80",
    description: {
      fr: "Contrat EPC+F pour la modernisation de 3 sites stratégiques GESTOCI (Abidjan, Yamoussoukro, San-Pédro). Infrastructure de stockage national d'importance systémique.",
      en: "EPC+F contract for the modernization of 3 strategic GESTOCI sites (Abidjan, Yamoussoukro, San-Pédro). Nationally significant storage infrastructure.",
    },
    partners: ["GESTOCI", "Wayne Africa"],
    kpis: [
      { value: "3", label: { fr: "Sites stratégiques", en: "Strategic sites" } },
      { value: "EPC+F", label: { fr: "Contrat clé en main", en: "Turnkey contract" } },
      { value: "CI", label: { fr: "Couverture nationale", en: "National coverage" } },
    ],
    locations: [
      { name: "Abidjan", x: 59, y: 83 },
      { name: "Yamoussoukro", x: 51, y: 61 },
      { name: "San-Pédro", x: 24, y: 89 },
    ],
  },
];

export const PROJECT_TYPE_COLOR = {
  immobilier: "#E8611A",
  energie: "#E30613",
  tourisme: "#00B894",
  infrastructure: "#C49A3C",
};

export const PARTNERS = [
  "Wayne Technologies",
  "Wayne Africa",
  "Zebra Technologies",
  "Beachcomber Hotels",
  "GESTOCI",
  "Grant Thornton",
  "SIB",
  "SGBCI",
];

// Mock news — will be seeded to Mongo via backend, but kept here as fallback
export const MOCK_NEWS = [
  {
    slug: "vision-2035-lancement",
    title: {
      fr: "Lancement opérationnel du programme Vision 2035",
      en: "Vision 2035 program operational launch",
    },
    excerpt: {
      fr: "EKIP Holding officialise le démarrage des travaux du premier pôle urbain de Vision 2035 à Angré.",
      en: "EKIP Holding officially starts construction of the first Vision 2035 urban hub in Angré.",
    },
    category: "communique",
    date: "2026-11-14",
    image: "https://images.pexels.com/photos/9321327/pexels-photo-9321327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "partenariat-beachcomber",
    title: {
      fr: "EKIP signe une joint-venture avec Beachcomber Hotels",
      en: "EKIP signs a joint venture with Beachcomber Hotels",
    },
    excerpt: {
      fr: "Le resort de Sassandra sera opéré en partenariat avec le groupe hôtelier mauricien Beachcomber.",
      en: "The Sassandra resort will be operated in partnership with Mauritian hospitality group Beachcomber.",
    },
    category: "communique",
    date: "2026-10-02",
    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=compress&cs=tinysrgb&fm=jpg&w=1200&q=80",
  },
  {
    slug: "kipay-live",
    title: {
      fr: "KIPAY est disponible dans le premier réseau de stations Wayne",
      en: "KIPAY goes live in the first Wayne stations network",
    },
    excerpt: {
      fr: "Le wallet KIPAY est désormais accepté dans les stations Wayne pilotes d'Abidjan.",
      en: "The KIPAY wallet is now accepted at pilot Wayne stations in Abidjan.",
    },
    category: "evenement",
    date: "2026-09-18",
    image: "https://images.pexels.com/photos/30547579/pexels-photo-30547579.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "ekiptech-zebra",
    title: {
      fr: "EKIPTECH devient distributeur exclusif Zebra Technologies en Afrique de l'Ouest",
      en: "EKIPTECH becomes exclusive Zebra Technologies distributor for West Africa",
    },
    excerpt: {
      fr: "Nouvelle étape stratégique dans l'écosystème technologique du groupe.",
      en: "A new strategic step in the group's technology ecosystem.",
    },
    category: "media",
    date: "2026-07-25",
    image: "https://images.pexels.com/photos/30547579/pexels-photo-30547579.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "publication-impact-2026",
    title: {
      fr: "Rapport d'Impact 2026 — nos avancées",
      en: "2026 Impact Report — our progress",
    },
    excerpt: {
      fr: "Publication du rapport annuel d'impact social et économique du groupe EKIP.",
      en: "Publication of EKIP group's annual social and economic impact report.",
    },
    category: "publication",
    date: "2026-06-30",
    image: "https://images.pexels.com/photos/32168739/pexels-photo-32168739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_holding-refresh/artifacts/1lj7dhux_Logo%20Holding_OS%20%2856%29.png";

export const LOGO_URL_LIGHT =
  "https://customer-assets.emergentagent.com/job_holding-refresh/artifacts/1lj7dhux_Logo%20Holding_OS%20%2856%29.png";

export const LOGO_URL_ICON =
  "https://customer-assets.emergentagent.com/job_85b4a918-c001-43f5-aa44-d6a2b40a6523/artifacts/6lj5m4f5_D7E9E15F-E269-46A1-81C7-2334B236A3E3.png";
